import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
// import Modal from 'react-awesome-modal'
import { Button } from 'loyal-react'
import RegulationsModalContent from './RegulationsModalContent'
import AriaModal from 'react-aria-modal'
// import { connect } from 'react-redux'

class RegulationModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isButtonDisabled: true
    }
    this.acceptTerms = this.props.acceptTerms
  }

  handleIsButtonDisabled (isDisabled) {
    this.setState({ isButtonDisabled: isDisabled })
  }

  setScrollToBottom = event => {
    const modalScroll = event.target
    if (!modalScroll) {
      return
    }
    const scrollValue = Math.trunc(modalScroll.scrollHeight) - Math.trunc(modalScroll.scrollTop) - 2
    if (
      scrollValue <=
      Math.trunc(modalScroll.clientHeight)
    ) {
      this.handleIsButtonDisabled(false)
    }
  }

  render () {
    const modal = this.props.showTerms ? (
      <AriaModal
        show
        dialogId='react-aria-modal-dialog'
        titleText='Teste regulamento'
        focusDialog='true'
        underlayStyle={{ zIndex: 9999 }}
        dialogStyle={{ width: '100%', maxWidth: '1101px' }}
      >
        <Fragment>
          <div
            className='container-fluid container-nps py-0'
            data-campaign={process.env.REACT_APP_CATALOG_ID}
          >
            <div className='container pt-3 pt-md-0'>
              <div className='row'>
                <div
                  className={`col-12 bg-white py-3 px-1 px-md-0 mr-auto ml-auto`}
                >
                  <div className='row px-0 px-md-2'>
                    <div className='col'>
                      <h2 className='txt-font-title'>Termos do regulamento</h2>
                    </div>
                  </div>
                  <div className='col-12'>
                    <div className='row px-0 px-md-3'>
                      <div className='col mx-0 mt-2 pl-2 pl-md-3 pr-1 py-3 bg-ui-4 border border-color-ui-3'>
                        <div className='row mr-1'>
                          <div
                            onScroll={e => this.setScrollToBottom(e, this)}
                            className='col-12 pr-1 pr-md-3 modal-scroll modalRegulation color-ui-2 txt-font-body txt-body-sm'
                          >
                            <RegulationsModalContent
                              content={this.props.content}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-12 pt-3'>
                    <div className='row align-items-center h-100 px-0 px-md-3'>
                      <div className='col-12 col-md mb-2 mb-md-0'>
                        <p className='txt-body'>O botão será habilitado após a leitura do documento.</p>
                      </div>
                      <div className='modal-back mx-auto ml-md-auto mr-md-0 col-auto col-md-5 px-0 txt-right'>
                        <Button
                          id={'Agree-Terms'}
                          name={'Agree'}
                          className='btn btn-featured mx-0'
                          text='LI E ACEITO'
                          onClick={this.acceptTerms}
                          loading={this.props.isLoading}
                          disabled={this.state.isButtonDisabled}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      </AriaModal>
    ) : (
      ''
    )
    return modal
  }
}

RegulationModal.propTypes = {
  showTerms: PropTypes.bool,
  acceptTerms: PropTypes.func,
  content: PropTypes.string,
  isLoading: PropTypes.bool
}

export default RegulationModal



// WEBPACK FOOTER //
// ./src/features/RegulationModal/RegulationsModal.js